function togglePasswordVisibility(inputId) {
    var passwordInput = document.getElementById(inputId);
    var toggleButton = document.querySelector('[onclick="togglePasswordVisibility(\'' + inputId + '\')"]');

    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        //toggleButton.innerHTML = '<img src="<?php echo esc_url(MISSJONES_URL . 'public / images / mj - eye - icon - hide.svg'); ?>" alt="">';
    } else {
        passwordInput.type = 'password';
        //toggleButton.innerHTML = '<img src="<?php echo esc_url(MISSJONES_URL . 'public / images / mj - eye - icon.svg'); ?>" alt="">';
    }
}

function updateProgressBar(action) {
    if (jQuery('.mj-form__progress-bar').length > 0) {
        const dataSteps = jQuery('.mj-form-progress-bar__wrapper').data('steps');
        if (!isNaN(dataSteps) && dataSteps > 0) {
            // Calculate the new width
            var wrapperWidth = parseFloat(jQuery('.mj-form-progress-bar__wrapper').css('width'));
            var barWidth = parseFloat(jQuery('.mj-form__progress-bar').css('width'));
            var currentWidth = Math.round(parseFloat(barWidth / wrapperWidth) * 100);
            var newWidth;

            if (action === 'increase') {
                newWidth = currentWidth + (1 / dataSteps) * 100;
            } else if (action === 'decrease') {
                newWidth = currentWidth - (1 / dataSteps) * 100;
            }

            // Ensure the new width is within valid bounds
            newWidth = Math.max(0, Math.min(100, newWidth));

            jQuery('.mj-form__progress-bar').css('width', newWidth + '%');
        }
    } else {
        console.log("failed updating progress bar");
    }
}

document.addEventListener('DOMContentLoaded', function () {

    // Get a reference to the parent container of the radio buttons
    const radioButtonsContainer = document.querySelector('.mj-form');

    if (radioButtonsContainer) {
        // Event listener for radio button changes
        radioButtonsContainer.addEventListener('change', function (event) {
            if (event.target.type === 'radio' && event.target.name === 'commission') {
                const otherRadioButton = document.querySelector('#commission-4');
                const customCommissionField = document.querySelector('.custom-commision');
                const customCommissionInput = document.querySelector('#commission-rate');

                if (otherRadioButton && customCommissionField) {
                    if (otherRadioButton.checked) {
                        customCommissionField.style.display = 'block';
                        customCommissionInput.setAttribute('required', '');
                    } else {
                        customCommissionField.style.display = 'none';
                        customCommissionInput.removeAttribute('required');
                    }
                }
            }
        });
    }
});

function validateStep(step) {
    clearErrorMessages(step); // Clear existing error messages

    const inputs = document.querySelectorAll(`.step-${step} .mj-form__input[required]`);
    let isValid = true;

    console.log(inputs);

    inputs.forEach((input) => {
        const label = input.closest(".mj-form-group__item").querySelector(".mj-form__label");

        if (input.type === "radio") {
            // Check if at least one radio button in the group is checked
            const radioButtons = document.querySelectorAll(`input[name="${input.name}"]`);
            const isRadioGroupValid = Array.from(radioButtons).some((radio) => radio.checked);
            if (!isRadioGroupValid) {
                isValid = false;
                displayErrorMessage(label, "Please select an option");
            }
        } else if (input.type === "email") {
            if (!validateEmail(input.value)) {
                isValid = false;
                displayErrorMessage(label, "Invalid email address");
            }

        } else if (input.type === "password" || input.type === "text") {
            if (input.getAttribute("data-length")) {
                const requiredLength = parseInt(input.getAttribute("data-length"));
                if (input.value.length < requiredLength) {
                    isValid = false;
                    displayErrorMessage(label, `Must be at least ${requiredLength} characters`);
                }
            }
        }

        if (input.id === "city") {
            if (input.tagName === 'SELECT') {
                const selectedValue = input.options[input.selectedIndex].text;
                if (selectedValue === '-') {
                    isValid = false;
                }
            }
        }

        if (input.id === "confirm-password") {
            const passwordInput = document.getElementById("password");

            if (input.value !== passwordInput.value) {
                isValid = false;
                displayErrorMessage(label, "Passwords do not match");
            }
        }

        if (!input.value.trim()) {
            isValid = false;
            displayErrorMessage(label, "This field is required");
        }
    });

    if (!isValid) {
        // Find all elements with the class .mj-form__error-message
        var $errorMessages = $('.mj-form__error-message');

        // Filter these elements to find the first one that contains the text "This field is required"
        var $requiredFieldError = $errorMessages.filter(function () {
            return $(this).text().trim() === "This field is required";
        }).first();

        // If such an element exists, scroll the page to this element
        if ($requiredFieldError.length > 0) {
            $('html, body').animate({
                scrollTop: $requiredFieldError.offset().top
            }, 100); // Adjust the duration (1000 milliseconds here) as needed
        }
    }

    if (step == 2) {
        const signatureUrl = sessionStorage.getItem('signature-url');
        const signatureImage = document.querySelector('#signature-url');

        // Check if signature_url exists and is not empty
        if (!signatureUrl || signatureUrl.trim() == '') {
            // Check if signature is empty

            if (signaturePad) {

                if (signaturePad.isEmpty()) {
                    isValid = false;
                    showNotification("You haven't signed the Signing Agreement.", 'error');
                } else {
                    // Check if signature_image exists and its value is empty
                    if (signatureImage && !signatureImage.value.trim()) {
                        isValid = false;
                        showNotification("Please confirm the signature", 'error');
                    }
                }
            }
        }
    }

    const venuePhotos = document.querySelector('#venue-photos-ids');

    if (venuePhotos && venuePhotos.value.trim() === '') {
        showNotification("Please upload at least one photo of your venue.", 'error');
        isValid = false;
    }

    const spacePhotos = document.querySelector('#space-photos-ids');

    if (spacePhotos && spacePhotos.value.trim() === '') {
        showNotification("Please upload at least one photo of your space.", 'error');
        isValid = false;
    }

    const supplierPhotos = document.querySelector('#supplier-photos-ids');

    if (supplierPhotos && supplierPhotos.value.trim() === '') {
        showNotification("Please upload at least one photo of your service.", 'error');
        isValid = false;
    }

    return isValid;
}

function validateForm(wrapper) {
    clearErrorMessages(wrapper); // Clear existing error messages

    const inputs = document.querySelectorAll(wrapper + ` .mj-form__input[required]`);
    let isValid = true;

    inputs.forEach((input) => {
        const label = input.closest(".mj-form-group__item").querySelector(".mj-form__label");
        if (input.type === "radio") {
            // Check if at least one radio button in the group is checked
            const radioButtons = document.querySelectorAll(`input[name="${input.name}"]`);
            const isRadioGroupValid = Array.from(radioButtons).some((radio) => radio.checked);
            if (!isRadioGroupValid) {
                isValid = false;
                displayErrorMessage(label, "Please select an option");
            }
        } else if (input.type === "email") {
            if (!validateEmail(input.value)) {
                isValid = false;
                displayErrorMessage(label, "Invalid email address");
            }

        } else if (input.type === "password" || input.type === "text") {
            if (input.getAttribute("data-length")) {
                const requiredLength = parseInt(input.getAttribute("data-length"));
                if (input.value.length < requiredLength) {
                    isValid = false;
                    displayErrorMessage(label, `The length of the characters should be at least ${requiredLength}`);
                }
            }
        }

        if (input.type === "password" && (input.id === "confirm-password")) {
            const passwordInput = document.getElementById("password");
            if (input.value !== passwordInput.value) {
                isValid = false;
                displayErrorMessage(label, "Passwords do not match!");
            }
        }

        if (!input.value.trim()) {
            isValid = false;
            displayErrorMessage(label, "Field is required!");
        }
    });

    if (!isValid) {
        // Find all elements with the class .form__error-message
        var $errorMessages = jQuery('.form__error-message');

        // Filter these elements to find the first one that contains the text "This field is required"
        var $requiredFieldError = $errorMessages.filter(function () {
            return jQuery(this).text().trim() === "This field is required";
        }).first();

        // If such an element exists, scroll the page to this element
        if ($requiredFieldError.length > 0) {
            jQuery('html, body').animate({
                scrollTop: $requiredFieldError.offset().top
            }, 100); // Adjust the duration (1000 milliseconds here) as needed
        }
    }

    return isValid;
}

function displayErrorMessage(label, message) {
    // Remove existing error messages
    const existingErrorMessages = label.parentNode.querySelectorAll(".mj-form__error-message");
    existingErrorMessages.forEach((errorMessage) => {
        errorMessage.remove();
    });

    // Add the new error message
    const newErrorMessage = document.createElement("span");
    newErrorMessage.className = "mj-form__error-message";
    newErrorMessage.textContent = message;
    label.appendChild(newErrorMessage);
}

function clearErrorMessages(step) {
    // Clear existing error messages for the current step
    const errorMessages = document.querySelectorAll(`.step-${step} .mj-form__error-message`);
    errorMessages.forEach((errorMessage) => {
        errorMessage.remove();
    });
}

function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

jQuery(document).ready(function () {

    // Add click event to multiselect__items-list options
    jQuery('.mj-form__container').on('click', '.multiselect__items-list option', function () {

        var selectedValue = jQuery(this).val();
        var selectedText = jQuery(this).text();

        const baseUrl = site_url_wpml(true);

        var imgURL = baseUrl + '/wp-content/plugins/missjones/public/images/mj-x-icon.svg';
        // Check if the value is already added
        if (jQuery('.mj-form__multiselect span[data-name="' + selectedValue + '"]').length === 0) {
            // Check if maximum allowed items are added
            if (jQuery('.mj-form__multiselect .mj-multiselect__value').length < 3) {
                // Add the selected item to mj-form__multiselect
                jQuery('.mj-form__multiselect').append('<span class="mj-multiselect__value" data-name="' + selectedValue + '"><span class="mj-multiselect-value__text">' + selectedText + '</span> |<img data-item="' + selectedValue + '" class="mj-remove__multiselect-value" src="' + imgURL + '" alt=""></span>');
            } else {
                // Handle maximum allowed items reached
                //alert('Maximum allowed items reached');
            }
        } else {
            // Item already added, remove it
            jQuery('.mj-form__multiselect span[data-name="' + selectedValue + '"]').remove();
        }

        // Update the hidden input with the selected values
        updateHiddenInput();
    });

    // Add click event to remove items
    // Use the static parent as a reference for delegation
    jQuery('.mj-form__container').on('click', '.mj-remove__multiselect-value', function () {
        var removedValue = jQuery(this).data('item');
        jQuery('.mj-form__multiselect span[data-name="' + removedValue + '"]').remove();
        // Update the hidden input with the selected values
        updateHiddenInput();
    });

    // Function to update the hidden input with selected values
    function updateHiddenInput() {
        var selectedValues = jQuery('.mj-form__multiselect span').map(function () {
            return jQuery(this).data('name');
        }).get().join(',');
        jQuery('.mj-form__multiselect-input').val(selectedValues);

        // Update Event Type text based on selected items
        if (jQuery('.mj-form__multiselect .mj-multiselect__value').length > 0) {
            jQuery('.mj-form__multiselect-placeholder').hide();
        } else {
            jQuery('.mj-form__multiselect-placeholder').show();
        }
    }
});

jQuery(document).ready(function ($) {

        const listWithUsForm = document.getElementById('list-with-us');

        if (!listWithUsForm) {
            // console.error('Form with ID "list-with-us" not found.');
            // return;
        } else {
            let currentStep = parseInt(sessionStorage.getItem('list-current-step')) || 1;
            let selectedType;

            const queryParams = new URLSearchParams(window.location.search);
            const queryType = queryParams.get('type');
            const queryAction = queryParams.get('action');

            if (queryAction && queryAction === 'edit') {
                const queryPostId = queryParams.get('id');
                const queryPrimary = queryParams.get('primary');
                const queryVenueId = queryParams.get('venue_id');

                currentStep = 1;
                selectedType = queryType;
                isPrimary = queryPrimary;
                restoreItemDataToSession(queryType, queryPostId, isPrimary, queryVenueId);

            } else if (queryAction && queryAction === 'add') {
                const queryVenueId = queryParams.get('venue_id');
                currentStep = 1;
                selectedType = queryType;

                saveFormData(currentStep, "space"); // Save the data before moving to the previous step
                saveCurrentStep(currentStep, "space");

                sessionStorage.setItem('createdPostId', queryVenueId);
                sessionStorage.setItem('edit-enabled', true);


                loadStepContent(selectedType, `step-${currentStep}`);

            } else {
                if (sessionStorage.getItem('list-selected-type')) {
                    selectedType = sessionStorage.getItem('list-selected-type');
                } else if (queryType) {
                    currentStep = 1;
                    selectedType = queryType;
                } else {
                    currentStep = 1;
                    selectedType = 'venue';
                }

                if (!isNaN(currentStep) && selectedType) {
                    loadStepContent(selectedType, `step-${currentStep}`);
                } else {
                    console.error('Invalid values retrieved from sessionStorage.');
                }
            }

        }


    function restoreItemDataToSession(formType, postId, isPrimary, venueId = null) {

        var ajaxData = {
            action: 'restore_item_data', // AJAX action hook
            type: formType,
            is_primary: isPrimary,
            post_id: postId,
            venue_id: venueId
        };

        $.ajax({
            type: 'POST',
            url: missjones_data.ajax_url,
            data: ajaxData,
            beforeSend: function () {

            },
            success: function (response) {
                // Loop through each item in the response
                Object.keys(response).forEach(function (key) {
                    // Parse JSON data
                    var itemListingData = response[key];
                    // Save the data to session storage
                    sessionStorage.setItem(key, JSON.stringify(itemListingData));
                });

                sessionStorage.setItem('edit-enabled', true);

                if (formType == "venue" && isPrimary == "true") {
                    const firstStep = Object.keys(response)[0];
                    const firstSession = response[firstStep];

                    const secondStep = Object.keys(response)[1];
                    const secondSession = response[secondStep];
                    sessionStorage.setItem('signature-url', secondSession['signature-url']);

                    const fourthStep = Object.keys(response)[3];
                    const fourthSession = response[fourthStep];

                    photosUrlsIds = fourthSession[formType + '-photos-ids'].split(',');
                    sessionStorage.setItem(formType + 'Photos', JSON.stringify(photosUrlsIds));

                    layoutUrlsIds = fourthSession[formType + '-plans-ids'].split(',');
                    sessionStorage.setItem(formType + 'Plans', JSON.stringify(layoutUrlsIds));

                    filesUrlsIds = fourthSession[formType + '-brochures-ids'].split(',');
                    sessionStorage.setItem(formType + 'Brochures', JSON.stringify(filesUrlsIds));

                    sessionStorage.setItem('createdPostId', postId);

                    loadStepContent(firstSession['business-type'], 'step-1');
                } else if (formType == "venue" && isPrimary == "false") {

                    const firstStep = Object.keys(response)[0];
                    const firstSession = response[firstStep];

                    photosUrlsIds = firstSession[formType + '-photos-ids'].split(',');
                    sessionStorage.setItem('spacePhotos', JSON.stringify(photosUrlsIds));

                    layoutUrlsIds = firstSession[formType + '-plans-ids'].split(',');
                    sessionStorage.setItem('spacePlans', JSON.stringify(layoutUrlsIds));

                    filesUrlsIds = firstSession[formType + '-brochures-ids'].split(',');
                    sessionStorage.setItem('spaceBrochures', JSON.stringify(filesUrlsIds));

                    sessionStorage.setItem('createdPostId', venueId);

                    loadStepContent("space", 'step-1', postId);


                } else if (formType == "supplier") {
                    const firstStep = Object.keys(response)[0];
                    const firstSession = response[firstStep];

                    const secondStep = Object.keys(response)[1];
                    const secondSession = response[secondStep];
                    sessionStorage.setItem('signature-url', secondSession['signature-url']);
                    const fourthStep = Object.keys(response)[3];
                    const fourthSession = response[fourthStep];

                    photosUrlsIds = fourthSession[formType + '-photos-ids'].split(',');
                    sessionStorage.setItem(formType + 'Photos', JSON.stringify(photosUrlsIds));

                    filesUrlsIds = fourthSession[formType + '-brochures-ids'].split(',');
                    sessionStorage.setItem(formType + 'Brochures', JSON.stringify(filesUrlsIds));

                    sessionStorage.setItem('createdPostId', postId);

                    loadStepContent("supplier", 'step-1');

                }
            },
            error: function () {
                console.error('AJAX error occurred.');
                showNotification('AJAX error occurred.', 'error');
            },
            complete: function () {
            }
        });
    }

    // Event handler for radio button click
    jQuery(document).on('click', '.mj-form__image-btn input[type="radio"]', function (e) {
        // Check which radio button is clicked
        // var selectedValue = $(this).val();
        // updateProgressBar('increase');
        // alert("clicked here");

        // // Load content dynamically based on the selected radio button
        // switch (selectedValue) {
        //     case 'venue':
        //         saveFormData(1, 'venue'); // Save the data before moving to the previous step
        //         saveCurrentStep(2, 'venue');
        //         loadStepContent('venue', 'step-2');
        //         break;
        //     case 'supplier':
        //         saveFormData(1, 'venue'); // Save the data before moving to the previous step
        //         saveCurrentStep(2, 'supplier');
        //         loadStepContent('supplier', 'step-3');
        //         break;
        //     // Add more cases for other radio button values if needed
        // }
    });

    jQuery(document).on('click', '.mj-form__progress-btn-next', function (e) {
        // Your click event handling code here
        e.preventDefault();
        let currentStep = parseInt(e.target.getAttribute("data-step"), 10);
        let currentType = e.target.getAttribute("data-type");
        let spaceValue = null;

        // if (e.target.hasAttribute("data-space-number")) {
        //     spaceKey = parseInt(e.target.getAttribute("data-space-number"), 10);
        // }

        if (e.target.hasAttribute("data-space-id")) {
            spaceValue = e.target.getAttribute("data-space-id"), 10;

            if (spaceValue.toString().trim() == '') {
                //This means the space is going to be created!
                spaceValue = "temp";
            }
        }

        if (validateStep(currentStep)) {
            // e.target.classList.add('--deactive');

            if (currentType == "space") {
                updateVenueSpacesSession(spaceValue);
            }

            saveFormData(currentStep, currentType, spaceValue); // Save the data before moving to the previous step
            saveCurrentStep(currentStep + 1, currentType);

            loadStepContent(currentType, 'step-' + (currentStep + 1), spaceValue);
            updateProgressBar('increase');
        }
    });

    jQuery(document).on('click', '.mj-form__btn-confirm', function (e) {
        // Your click event handling code here
        e.preventDefault();
        let currentStep = parseInt(e.target.getAttribute("data-step"), 10);
        let currentType = e.target.getAttribute("data-type");
        let spaceValue = null;

        loadStepContent(currentType, 'step-' + (currentStep + 1), spaceValue);
    });

    function updateVenueSpacesSession(spaceValue) {

        spaceValue = parseInt(spaceValue.toString().trim()); // Trim spaces and convert to integer

        var venueSpaces = sessionStorage.getItem('venueSpaces') ? JSON.parse(sessionStorage.getItem('venueSpaces')) : [];

        var matchFound = venueSpaces.includes(spaceValue);

        if (!matchFound) {
            // Add spaceValue to venueSpaces array
            venueSpaces.push(spaceValue);

            // Update sessionStorage with the modified array
            sessionStorage.setItem('venueSpaces', JSON.stringify(venueSpaces));

        } else {
            console.log("Match found for spaceValue:", spaceValue);
        }
    }


    jQuery(document).on('click', '.mj-form__progress-btn-prev', function (e) {
        // Your click event handling code here
        e.preventDefault();
        let currentStep = parseInt(e.target.getAttribute("data-step"), 10);
        let currentType = e.target.getAttribute("data-type");

        saveFormData(currentStep, currentType); // Save the data before moving to the previous step
        saveCurrentStep(currentStep - 1, currentType);
        loadStepContent(currentType, 'step-' + (currentStep - 1));
        updateProgressBar('decrease');
    });

    jQuery(document).on('click', '.mj-form__create-space', function (e) {
        // Your click event handling code here
        e.preventDefault();
        let currentStep = parseInt(e.target.getAttribute("data-step"), 10);
        let currentType = e.target.getAttribute("data-type");

        saveFormData(currentStep, "space"); // Save the data before moving to the previous step
        saveCurrentStep(currentStep, "space");
        loadStepContent(currentType, 'step-' + currentStep);
    });

    jQuery(document).on('click', '.mj-form__edit-details', function (e) {
        // Your click event handling code here
        e.preventDefault();
        let currentStep = parseInt(e.target.getAttribute("data-step"), 10);
        let currentType = e.target.getAttribute("data-type");
        let spaceValue = e.target.getAttribute("data-space-id");

        if (spaceValue == 'null') {
            spaceValue = null;
        } else {
            spaceValue = parseInt(spaceValue, 10);
        }

        // sessionStorage.setItem('currentSpaceId', spaceID);
        // let spaceKey = getSpaceKeyByValue(spaceValue);
        // saveFormData(currentStep, "space", spaceID); // Save the data before moving to the previous step
        saveCurrentStep(currentStep, currentType);
        loadStepContent(currentType, 'step-' + currentStep, spaceValue);
    });

    function gatherFormData(formType, numberOfSteps) {
        // Initialize an empty object to store the merged data
        var allFormData = {};

        // Loop through each step
        for (var step = 1; step <= numberOfSteps; step++) {
            // Get the stored data from sessionStorage for the current step
            var storedFormData = sessionStorage.getItem(formType + 'ListingData' + step);

            // Parse the stored data as JSON only if it's a string
            var stepFormData = (typeof storedFormData === 'string') ? JSON.parse(storedFormData) : storedFormData || {};

            // Merge the data into the 'allFormData' object
            Object.assign(allFormData, stepFormData);
        }

        // Convert the JavaScript object to a JSON string
        var jsonData = JSON.stringify(allFormData);

        return jsonData;
    }

    function gatherSpaceData(formType, spaceID) {
        // Initialize an empty object to store the form data
        var allFormData = {};

        spaceID = spaceID.toString().trim();
        // Retrieve the stored data from sessionStorage using the spaceID
        var storedFormData = sessionStorage.getItem(formType + spaceID + 'ListingData');

        // Parse the stored data as JSON only if it's a string
        var stepFormData = (typeof storedFormData === 'string') ? JSON.parse(storedFormData) : storedFormData || {};

        // Merge the retrieved data into the 'allFormData' object
        Object.assign(allFormData, stepFormData);

        // Convert the JavaScript object to a JSON string
        var jsonData = JSON.stringify(allFormData);

        return jsonData;
    }

    function displayFormDataReport(formType, numberOfSteps) {
        // Get the gathered form data
        var jsonData = gatherFormData(formType, numberOfSteps);


        // Parse the JSON data back to an object for better formatting
        var formDataObj = JSON.parse(jsonData);

        // Build an HTML string for the report
        var htmlReport = '<h2>Form Data Report</h2>';
        htmlReport += '<ul>';

        for (var key in formDataObj) {
            htmlReport += '<li><strong>' + key + ':</strong> ' + formDataObj[key] + '</li>';
        }

        htmlReport += '</ul>';

        // Display the report in the #report div element
        document.querySelector('.mj-list-with-us').innerHTML = htmlReport;
    }


    // Function to load content dynamically using AJAX
    function loadStepContent(formType, stepId, spaceID = null) {

        var step_number = parseInt(stepId.match(/\d+/)[0]);

        var ajaxData = {
            action: 'get_step_content', // AJAX action hook
            step_id: stepId,
            step: step_number,
            form_type: formType,
            space_id: spaceID
        };

        if (sessionStorage.getItem('createdPostId') !== null) {
            ajaxData.post_id = sessionStorage.getItem('createdPostId');
        }

        if (formType == "space") {
            if (spaceID != null) {
                ajaxData.jsonData = gatherSpaceData(formType, spaceID);
            }
        } else if ((formType == "venue" || formType == "supplier") && step_number == 5) {
            ajaxData.jsonData = gatherFormData(formType, 4);
        }

        $.ajax({
            type: 'post',
            url: missjones_data.ajax_url,
            data: ajaxData,
            beforeSend: function () {
                $('html, body').animate({
                    scrollTop: 0
                }, '100');
                jQuery('.mj-form__steps-container').html('<div class="loading-spinner__container"><div class="loading-spinner"></div></div>');
                //displayFormDataReport(formType, 3);
            },
            success: function (response) {
                if (response.success === true) {
                    // Replace content with the loaded HTML
                    if ((sessionStorage.getItem('edit-enabled')) && ((formType == "venue" && step_number == 5) || formType == "space" && step_number == 2) || (formType == "supplier" && step_number == 7)) {
                        var siteUrl = site_url_wpml();
                        window.location.href = siteUrl + '/dashboard/?menu=listing&tab=pending-listing';
                    } else {
                        jQuery('.mj-form__steps-container').html(response.data.content);
                    }
                    if (step_number == 5) {
                        //displayFormDataReport(formType, 3);
                        if (response.data.venue_id) {
                            sessionStorage.setItem('createdPostId', response.data.venue_id);
                        }
                    } else if (step_number == 2 && formType == "space") {
                        if (response.data.venue_id) {
                            sessionStorage.setItem('createdPostId', response.data.venue_id);
                            updateVenueSpacesSession(response.data.space_id);

                            //This means the space is created and we're going to the review page
                            if (spaceID == "temp") {
                                var spacetempListingData = sessionStorage.getItem('spacetempListingData');

                                // Move the temp session data to the real session space
                                if (spacetempListingData !== null && spacetempListingData !== undefined && spacetempListingData !== '') {
                                    var spaceListingData = 'space' + response.data.space_id + 'ListingData';
                                    sessionStorage.setItem(spaceListingData, spacetempListingData);
                                    let newSessionValue = sessionStorage.getItem(spaceListingData);
                                }
                            }
                            spaceID = response.data.space_id;
                        }
                    }

                    if ((formType == "venue" && step_number == 6) || (formType == "space" && step_number == 3) || (formType == "supplier" && step_number == 5)) {
                        sessionStorage.clear();
                    }

                    restoreFormData(step_number, formType, spaceID);
                    initializeCountries();

                    initializeDropzone();

                    if (step_number == 3 && (formType == "venue" || formType == "supplier")) {
                        currentSessionStorage = sessionStorage.getItem(formType + "Listing" + stepId);

                        // Check if item exists in sessionStorage
                        if (sessionStorage.getItem('location-latlng')) {
                            // If it exists, try to parse its data as JSON
                            var storedCoordinates = (sessionStorage.getItem('location-latlng'));
                            const [lat, lng] = storedCoordinates.split(',');

                            coordinatesPosition = {
                                lat: parseFloat(lat.trim()),
                                lng: parseFloat(lng.trim())
                            };

                        } else {
                            // If it doesn't exist, set the default value to London Eye coordinates
                            var coordinatesPosition = { lat: 51.5033, lng: -0.1195 }; // London Eye coordinates
                        }

                        // Convert the coordinatesPosition object to numbers
                        const defaultPosition = { lat: Number(coordinatesPosition.lat), lng: Number(coordinatesPosition.lng) };

                        initVenueMap(coordinatesPosition);
                    }
                    if (step_number == 2 && (formType == "venue" || formType == "supplier")) {
                        initializeSignaturePad();
                        flatpickr("#agreement-date", {
                            enableTime: false,
                            dateFormat: "d-m-Y", // Displays: 2017-01-22Z
                        });
                    }

                    priceUnitFunctions();

                    restoreDropZoneFiles();

                    // if (step_number == 4 && (formType == "venue" || formType == "supplier")) {
                    // }

                    initializePricesActions();


                } else {
                    // Handle error
                    console.error('Error loading step content.');
                }

                // Get the current URL's query parameters
                const urlParams = new URLSearchParams(window.location.search);

                // Check if 'action=edit' exists
                if (urlParams.get('action') === 'edit') {
                    const occasionFields = document.querySelector('#occasion-fields');
                    if (occasionFields) {
                        occasionFields.classList.add('--mj-element-deactivated');
                    }

                    const excellencesFields = document.querySelector('#excellences-fields');
                    if (excellencesFields) {
                        excellencesFields.classList.add('--mj-element-deactivated');
                    }
                }
            },
            error: function () {
                // Handle AJAX error
                console.error('AJAX error occurred.');
            },
        });
    }

    function priceUnitFunctions() {
        // Get all select elements with the class 'price-symbol-selector'
        const priceSelectors = document.querySelectorAll('.price-symbol-selector');
        const priceUnitInput = document.getElementById('price-unit');

        // Function to update all select elements and hidden input
        function updateSelectors(selectedValue) {
            priceSelectors.forEach(function (selector) {
                selector.value = selectedValue;
            });
            priceUnitInput.value = selectedValue;
        }

        // Add event listener to each select element
        priceSelectors.forEach(function (selector) {
            selector.addEventListener('change', function () {
                const selectedValue = this.value;
                console.log("yes!!");
                updateSelectors(selectedValue);
            });
        });

        // If #price-unit element exists, get its value
        if (priceUnitInput) {
            const currentValue = priceUnitInput.value;
            // Loop through all the priceSelectors and set the selected option
            priceSelectors.forEach(function (selector) {
                selector.value = currentValue;
            });
        }
    }

    function restorePricingData(step, formType, keyword) {
        if (jQuery(`.pricing-${keyword}__wrapper`).length > 0) {
            let priceElementCheckbox = document.querySelector('.mj_listing_pricing_checkbox[data-type="' + keyword + '"]');

            if (priceElementCheckbox) {
                let priceElementCheckboxChecked = priceElementCheckbox.checked;
                let pricesWrapper = document.querySelector('.pricing-options__wrapper[data-type="' + keyword + '"]');

                if (pricesWrapper) {
                    if (priceElementCheckboxChecked) {
                        // Add Class --show
                        document.querySelector('.pricing-options__wrapper[data-type="' + keyword + '"]').classList.add('--show');
                    } else {
                        // Remove Class --show
                        document.querySelector('.pricing-options__wrapper[data-type="' + keyword + '"]').classList.remove('--show');
                    }
                }
            }

            // Construct the sessionStorage key based on formType and step
            var sessionStorageKey = formType + `ListingData` + step;

            // Get stored data from sessionStorage
            var storedFormData = sessionStorage.getItem(sessionStorageKey);

            // Check if there's stored data
            if (storedFormData) {
                // Parse the JSON string to get the original object
                var formData = JSON.parse(storedFormData);

                // Group keys based on their numeric suffix
                var groupedKeys = {};
                for (var key in formData) {
                    // var match = key.match(/(\D+)(\d+)$/); // Extract non-digit part and digit part
                    var match = key.match(new RegExp('^' + keyword + '([^\\d]+)(\\d+)$'));

                    if (match) {
                        var prefix = match[1];
                        var suffix = match[2];
                        if (!groupedKeys[suffix]) {
                            groupedKeys[suffix] = {};
                        }
                        groupedKeys[suffix][prefix] = formData[key];
                    }
                }

                // Loop through grouped keys starting from the second suffix
                for (var suffix in groupedKeys) {
                    if (suffix !== '1') {
                        var newRow = $(`.mj-pricing__${keyword}`).first().clone();
                        var hasEmptyValues = true;

                        newRow.find("select:not(.mj-form__price-prefix), input").each(function () {
                            var originalName = $(this).attr("name");
                            var value = formData[originalName];

                            console.log(this);
                            console.log(originalId);
                            var originalId = $(this).attr("id");
                            var newId = originalId.replace(/_\d+$/, `_${suffix}`);
                            var newName = originalName.replace(/_\d+$/, `_${suffix}`);

                            $(this).attr("id", newId);
                            $(this).attr("name", newName);
                            // Set values from sessionStorage
                            $(this).val(formData[newName]);

                        });

                        // Add an incremental ID to the new row
                        var newRowId = `mj-pricing__${keyword}-${suffix}`;
                        newRow.attr("id", newRowId);
                        newRow.find(".remove-pricing-row").attr("data-price-row-id", suffix);

                        jQuery(`.pricing-${keyword}__wrapper`).append(newRow);

                        // Append the new row to the wrapper only if it has non-empty values
                        //if (!hasEmptyValues) {
                    }
                }
            }
        }
    }

    function restoreVideoData(step, formType) {
        if (jQuery(`.mj-${formType}-video__container`).length > 0) {

            // Construct the sessionStorage key based on formType and step
            var sessionStorageKey = formType + `ListingData` + step;

            // Get stored data from sessionStorage
            var storedFormData = sessionStorage.getItem(sessionStorageKey);

            // Check if there's stored data
            if (storedFormData) {
                // Parse the JSON string to get the original object
                var formData = JSON.parse(storedFormData);

                // Group keys based on their numeric suffix
                var groupedKeys = {};
                for (var key in formData) {
                    // var match = key.match(/(\D+)(\d+)$/); // Extract non-digit part and digit part
                    // var match = key.match(new RegExp('^(video_source_|video_url_)([^\\d]+)(\\d+)$'));
                    var match = key.match(/^(video_(url|source))_(\d+)$/);

                    if (match) {
                        var prefix = match[2]; // Accessing the second capturing group for 'url' or 'source'
                        var suffix = match[3]; // Accessing the third capturing group for the number
                        if (!groupedKeys[suffix]) {
                            groupedKeys[suffix] = {};
                        }
                        groupedKeys[suffix][prefix] = formData[key];
                    }
                }

                // Loop through grouped keys starting from the second suffix
                for (var suffix in groupedKeys) {
                    if (suffix !== '1') {
                        var newRow = $(`.mj-${formType}-video`).first().clone();

                        newRow.find("select, input").each(function () {
                            var originalName = $(this).attr("name");

                            var originalId = $(this).attr("id");
                            var newId = originalId.replace(/_\d+$/, `_${suffix}`);

                            var newName = originalName.replace(/_\d+$/, `_${suffix}`);


                            $(this).attr("id", newId);
                            $(this).attr("name", newName);
                            // Set values from sessionStorage
                            $(this).val(formData[newName]);

                        });

                        // Add an incremental ID to the new row
                        var newRowId = `video_section_${suffix}`;
                        newRow.attr("id", newRowId);
                        newRow.find(".remove-video-row").attr("data-video-row-id", suffix);

                        jQuery(`.mj-${formType}-video__container`).append(newRow);

                    }
                }
            }
        }
    }

    function restoreServicesData(step, formType) {
        if (jQuery(`.mj-${formType}-services__container`).length > 0) {

            // Construct the sessionStorage key based on formType and step
            var sessionStorageKey = formType + `ListingData` + step;

            // Get stored data from sessionStorage
            var storedFormData = sessionStorage.getItem(sessionStorageKey);

            // Check if there's stored data
            if (storedFormData) {
                // Parse the JSON string to get the original object
                var formData = JSON.parse(storedFormData);

                // Group keys based on their numeric suffix
                var groupedKeys = {};
                for (var key in formData) {
                    // var match = key.match(/(\D+)(\d+)$/); // Extract non-digit part and digit part
                    // var match = key.match(new RegExp('^(video_source_|video_url_)([^\\d]+)(\\d+)$'));
                    var match = key.match(/^(service_(name|category))_(\d+)$/);

                    if (match) {
                        var prefix = match[2]; // Accessing the second capturing group for 'url' or 'source'
                        var suffix = match[3]; // Accessing the third capturing group for the number
                        if (!groupedKeys[suffix]) {
                            groupedKeys[suffix] = {};
                        }
                        groupedKeys[suffix][prefix] = formData[key];
                    }
                }

                // Loop through grouped keys starting from the second suffix
                for (var suffix in groupedKeys) {
                    if (suffix !== '1') {
                        var newRow = $(`.mj-${formType}-service`).first().clone();

                        newRow.find("select, input").each(function () {
                            var originalName = $(this).attr("name");

                            var originalId = $(this).attr("id");
                            var newId = originalId.replace(/_\d+$/, `_${suffix}`);

                            var newName = originalName.replace(/_\d+$/, `_${suffix}`);


                            $(this).attr("id", newId);
                            $(this).attr("name", newName);
                            // Set values from sessionStorage
                            $(this).val(formData[newName]);

                        });

                        // Add an incremental ID to the new row
                        var newRowId = `service_section_${suffix}`;
                        newRow.attr("id", newRowId);
                        newRow.find(".remove-service-row").attr("data-service-row-id", suffix);

                        jQuery(`.mj-${formType}-services__container`).append(newRow);

                    }
                }
            }
        }
    }


    function restoreDropZoneFiles() {

        var uploadIcon = site_url_wpml(true) + 'wp-content/plugins/missjones/public/images/mj-upload-icon.svg';
        var trashIcon = site_url_wpml(true) + 'wp-content/plugins/missjones/public/images/mj-trash-icon.svg';

        // Loop through .uploads-ids-container elements
        jQuery('.uploads-ids-container').each(function () {
            $currentTarget = jQuery(this);
            // Get data-upload-type attribute value
            var uploadType = jQuery(this).data('upload-type');
            var sessionName = jQuery(this).data('session-name');

            var sessionFilesArray = JSON.parse(sessionStorage.getItem(sessionName)) || [];

            var sessionFiles = sessionFilesArray.join(',');

            jQuery(this).val(sessionFiles);

            // Get the comma-separated values from the hidden input
            var fileUrlsString = jQuery(this).val();

            var fileUrls = fileUrlsString.trim() === '' ? [] : fileUrlsString.split(',');

            $currentTarget.next().find('span').text(getTotalUploadedFiles(fileUrlsString, $currentTarget.next().find('span')));

            var previewContainer = jQuery(this).prev('.uploads__preview_container');

            // Check if uploadType is "photo"
            if (uploadType === 'photo') {
                // Loop through the array and create image elements inside the preview container
                jQuery.each(fileUrls, function (index, imageUrl) {
                    // Create preview element
                    var preview = jQuery('<div>', { class: 'uploaded_file dz-preview dz-image-preview dz-success dz-complete' });

                    // Create image element inside the preview
                    var img = jQuery('<img>', { 'data-dz-thumbnail': '', src: imageUrl, alt: 'Preview Image' });

                    // Append the image to the preview container
                    preview.append(jQuery('<div>', { class: 'dz-image' }).append(img));

                    // Append the additional HTML structure to the end of div.dz-preview
                    preview.append('<a class="dz-remove finished" href="javascript:undefined;" data-dz-remove=""><div class="mj-cancel-upload mj-cancel-upload-manual" data-src-file=' + imageUrl + `><img src='${trashIcon}'></div></a>`);

                    // Append the preview to the preview container
                    previewContainer.append(preview);
                });
            } else if (uploadType === 'file') {
                // Loop through the array and create image elements inside the preview container
                jQuery.each(fileUrls, function (index, fileUrl) {

                    // Get the file name from the file URL
                    var fileName = fileUrl.substring(fileUrl.lastIndexOf("/") + 1);
                    var mainFileName = fileName.split('_').slice(1).join('_');

                    // Create preview element
                    var preview = jQuery('<div>', { class: 'uploaded_file dz-preview dz-file-preview dz-success dz-complete' });

                    // Create image element inside the preview
                    var img = jQuery('<img>', { 'data-dz-thumbnail': '' });

                    // Append the image to the preview container
                    preview.append(jQuery('<div>', { class: 'dz-image' }).append(img));

                    // Create image element inside the preview
                    var detailsElement = jQuery('<div>', { class: 'dz-filename' });
                    var fileNameElement = jQuery('<span>', { class: 'data-dz-name' });

                    // Set the file name as the text content of the span.data-dz-name
                    fileNameElement.text(mainFileName);

                    detailsElement.append(fileNameElement);
                    // Append the image to the preview container
                    preview.append(jQuery('<div>', { class: 'dz-details' }).append(detailsElement));

                    // Append the additional HTML structure to the end of div.dz-preview
                    preview.append('<a class="dz-remove finished" href="javascript:undefined;" data-dz-remove=""><div class="mj-cancel-upload mj-cancel-upload-manual" data-src-file=' + fileUrl + `><img src='${trashIcon}'></div></a>`);

                    // Append the preview to the preview container
                    previewContainer.append(preview);
                });
            }
        });
    }

    // Function to collect and store form data for a specific step
    function saveFormData(step, formType, spaceID = null) {
        var storedFormData = sessionStorage.getItem(formType + 'ListingData' + step);
        var stepFormData = storedFormData ? JSON.parse(storedFormData) : {};

        var formElements = document.querySelectorAll('.step-' + step + ' input, .step-' + step + ' select, .step-' + step + ' textarea');

        formElements.forEach(function (element) {
            if (element.name && element.type !== 'submit' && element.type !== 'button') {
                if (element.type === 'checkbox') {
                    // Check if the property exists and is an array
                    stepFormData[element.name] = Array.isArray(stepFormData[element.name]) ? stepFormData[element.name] : [];

                    if (element.checked) {
                        // Add the new value
                        stepFormData[element.name].push(element.value);
                    } else {
                        // Remove the unchecked value
                        stepFormData[element.name] = stepFormData[element.name].filter(function (value) {
                            return value !== element.value;
                        });
                    }
                } else if (element.type === 'radio') {
                    if (element.checked) {
                        stepFormData[element.name] = element.value;
                    }
                } else if (element.tagName.toLowerCase() === 'select') {
                    stepFormData[element.name] = element.value;
                } else {
                    stepFormData[element.name] = element.value;
                }
            }
        });

        if (spaceID !== null && formType === "space") {
            spaceID = spaceID.toString().trim();
            let sessionName = formType + spaceID + 'ListingData';
            let sessionValue = JSON.stringify(stepFormData);

            sessionStorage.setItem(sessionName, sessionValue);
        } else {
            sessionStorage.setItem(formType + 'ListingData' + step, JSON.stringify(stepFormData));
        }
    }

    // Function to restore form data to the input, select, and textarea elements for a specific step
    function restoreFormData(step, formType, spaceID) {

        // Retrieve the formData JSON string from sessionStorage
        if (spaceID != null) {
            spaceID = spaceID.toString().trim();
            var storedFormData = sessionStorage.getItem(formType + spaceID + 'ListingData');
        } else {
            var storedFormData = sessionStorage.getItem(formType + 'ListingData' + step);
        }

        // Check if there's stored data
        if (storedFormData) {
            // Parse the JSON string to get the original object
            var formData = JSON.parse(storedFormData);

            // Iterate through each key in formData
            for (var key in formData) {
                // Check if the key exists in the form
                if (formData.hasOwnProperty(key)) {
                    // Get the form elements by name
                    var formElements = document.querySelectorAll('.step-' + step + ' [name="' + key + '"]');

                    if (formElements.length > 0) {
                        // Check if the form element is a select
                        if (formElements[0].tagName.toLowerCase() === 'select') {
                            // Update the selected option of the select element
                            formElements[0].value = formData[key];
                        } else if (formElements[0].type === 'checkbox') {
                            // Update the checked status of the checkbox
                            formElements.forEach(function (checkbox) {
                                checkbox.checked = Array.isArray(formData[key]) && formData[key].includes(checkbox.value);
                            });
                        } else if (formElements[0].type === 'radio') {
                            // Update the checked status of the radio button
                            formElements.forEach(function (radio) {
                                radio.checked = radio.value === formData[key];
                            });
                        } else {
                            // Update the value of the form element (for non-select and non-checkbox elements)
                            formElements[0].value = formData[key];
                        }
                    }
                }
            }
        }

        if (step == 3) {
            if (formData && formData.hasOwnProperty('map-latlang') && formData['map-latlang'] !== undefined) {
                // If formData exists and formData['map-latlang'] is not undefined, set the session item
                sessionStorage.setItem('location-latlng', formData['map-latlang']);
            } else {
                // If formData doesn't exist or formData['map-latlang'] is undefined, set it to the London Eye latlng
                var londonEyeLatlng = "51.5033, -0.1195"; // Latitude and Longitude of the London Eye
                sessionStorage.setItem('location-latlng', londonEyeLatlng);
            }
        }

        restoreVideoData(step, formType);
        restoreServicesData(step, formType);
        restorePricingData(step, formType, "show-pricing-options");
        restorePricingData(step, formType, "minspend");
        restorePricingData(step, formType, "perperson");
        restorePricingData(step, formType, "delegate");
        restorePricingData(step, formType, "hirefee");

        restoreCustomElements();
    }


    function saveCurrentStep(step, formType) {
        sessionStorage.setItem("list-current-step", step);
        sessionStorage.setItem("list-selected-type", formType);
    }

});

function restoreCustomElements() {

    /*Custom Commision Rate*/
    const otherRadioButton = document.querySelector('#commission-4');
    const customCommissionField = document.querySelector('.custom-commision');
    const customCommissionInput = document.querySelector('#commission-rate');

    // if (otherRadioButton && customCommissionField) {
    if (otherRadioButton && customCommissionField) {
        if (otherRadioButton.checked) {
            customCommissionField.style.display = 'block';
            customCommissionInput.setAttribute('required', '');
        } else {
            customCommissionField.style.display = 'none';
            customCommissionInput.removeAttribute('required');
        }
    }

    /*Space Layout Boxes*/
    const selectedSpaceLayouts = document.querySelectorAll('.mj-form__image-btn-group input:not([disabled])');

    selectedSpaceLayouts.forEach(layoutElement => {
        if (layoutElement.checked) {
            // Find the immediate parent with class 'mj-form__image-btn' and add 'active' class
            var parent = layoutElement.closest('.mj-form__image-btn');
            let item_slug = parent.dataset.id;
            let input_guest_number = jQuery(`#mj-layouts-guests-numbers .mj-form-group__item[data-id="${item_slug}"]`);

            if (parent) {
                parent.classList.add('active');
                input_guest_number.addClass('--show');
            }
        } else {
            // If the checkbox is not checked, remove 'active' class
            var parent = layoutElement.closest('.mj-form__image-btn');
            if (parent) {
                parent.classList.remove('active');
                //input_guest_number.removeClass('--show');
            }
        }
    });

}

jQuery(document).ready(function () {
    jQuery(document).on('change', '.mj-form__checkboxes-wrapper input[type="checkbox"]', function () {
        var $checkboxWrapper = jQuery(this).closest('.mj-form__checkboxes-wrapper');
        var groupName = $checkboxWrapper.data('group-name');
        var maxSelection = parseInt($checkboxWrapper.data('max-selection')) || Infinity;

        var selectedCheckboxes = $checkboxWrapper.find('input[type="checkbox"]:checked');

        if (selectedCheckboxes.length > maxSelection) {
            showNotification('You can only select up to ' + maxSelection + ' items from ' + groupName, 'error');
            jQuery(this).prop('checked', false); // Uncheck the last checkbox that caused the limit to be exceeded
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {

    const mjForm = document.querySelector('.mj-form');

    // Check if the .mj-form element is found
    if (mjForm) {
        // Add a click event listener to the static .mj-form element
        mjForm.addEventListener("click", function (event) {
            const target = event.target;

            // Check if the clicked element or its ancestor has the class .mj-form__image-btn
            // const imageBtn = target.closest(".mj-form__image-btn");
            const imageBtn = target.closest(".mj-form__image-btn:not(.disabled)");

            if (imageBtn) {
                // Find the checkbox inside the clicked .mj-form__image-btn
                const checkbox = imageBtn.querySelector("input[type='checkbox']");

                // Check if the checkbox is found before accessing its properties
                if (checkbox) {
                    checkbox.checked = !checkbox.checked;

                    let item_slug = imageBtn.dataset.id;
                    let input_guest_number = jQuery(`#mj-layouts-guests-numbers .mj-form-group__item[data-id="${item_slug}"]`);

                    if (checkbox.checked) {
                        imageBtn.classList.add("active");
                        input_guest_number.addClass('--show');
                    } else {
                        imageBtn.classList.remove("active");
                        input_guest_number.removeClass('--show');
                    }
                }
            }
        });
    }
});

document.addEventListener('click', function (event) {
    var multiselectContainer = event.target.closest('.mj-form__multiselect'); // Find the closest .mj-form__multiselect or its dynamically added parent

    if (multiselectContainer) {
        // Clicked inside .mj-form__multiselect or its dynamically added elements
        var resultsPanel = document.querySelector('.multiselect__results-panel'); // Find resultsPanel within the container

        // Check if the resultsPanel exists and is not hidden
        if (resultsPanel && !resultsPanel.classList.contains('hidden')) {
            resultsPanel.classList.add('show');
        }
    } else if (event.target.closest('.multiselect__results-panel')) {
        // Clicked inside .multiselect__results-panel, do nothing
    } else {
        // Clicked outside both
        var resultsPanel = document.querySelector('.multiselect__results-panel'); // Find resultsPanel outside the container

        // Check if the resultsPanel exists and is not hidden
        if (resultsPanel && !resultsPanel.classList.contains('hidden')) {
            resultsPanel.classList.remove('show');
        }
    }
});


function addMoreVideo() {
    // Clone the existing mj-space-video section
    var clonedSection = document.querySelector('.mj-venue-video').cloneNode(true);

    var lastItem = jQuery(".mj-venue-video:last-child");
    var spaceVideoCounter = parseInt(lastItem.attr("id").match(/\d+/)[0], 10);

    // Increment the counter for unique IDs
    spaceVideoCounter++;

    // Update the IDs in the cloned section
    clonedSection.id = 'video_section_' + spaceVideoCounter;
    clonedSection.querySelector('.mj-form__videosource').id = 'video_source_' + spaceVideoCounter;
    clonedSection.querySelector('.mj-form__videourl').id = 'video_url_' + spaceVideoCounter;
    clonedSection.querySelector('.mj-form__videosource').setAttribute('name', 'video_source_' + spaceVideoCounter);
    clonedSection.querySelector('.mj-form__videourl').setAttribute('name', 'video_url_' + spaceVideoCounter);
    clonedSection.querySelector('.remove-video-row').setAttribute('data-video-row-id', spaceVideoCounter);


    // Clear the input field in the cloned section
    clonedSection.querySelector('.mj-form__videourl').value = '';


    // Append the cloned section to the container
    document.querySelector('.mj-venue-video__container').appendChild(clonedSection);
}

function addMoreSupplierVideo() {
    // Clone the existing mj-space-video section
    var clonedSection = document.querySelector('.mj-supplier-video').cloneNode(true);

    var lastItem = jQuery(".mj-supplier-video:last-child");
    var spaceVideoCounter = parseInt(lastItem.attr("id").match(/\d+/)[0], 10);

    // Increment the counter for unique IDs
    spaceVideoCounter++;

    // Update the IDs in the cloned section
    clonedSection.id = 'video_section_' + spaceVideoCounter;
    clonedSection.querySelector('.mj-form__videosource').id = 'video_source_' + spaceVideoCounter;
    clonedSection.querySelector('.mj-form__videourl').id = 'video_url_' + spaceVideoCounter;
    clonedSection.querySelector('.mj-form__videosource').setAttribute('name', 'video_source_' + spaceVideoCounter);
    clonedSection.querySelector('.mj-form__videourl').setAttribute('name', 'video_url_' + spaceVideoCounter);
    clonedSection.querySelector('.remove-video-row').setAttribute('data-video-row-id', spaceVideoCounter);


    // Clear the input field in the cloned section
    clonedSection.querySelector('.mj-form__videourl').value = '';


    // Append the cloned section to the container
    document.querySelector('.mj-supplier-video__container').appendChild(clonedSection);
}

function addMoreService() {
    // Clone the existing mj-space-video section
    var clonedSection = document.querySelector('.mj-supplier-service').cloneNode(true);

    var lastItem = jQuery(".mj-supplier-service:last-child");
    var serviceCounter = parseInt(lastItem.attr("id").match(/\d+/)[0], 10);

    // Increment the counter for unique IDs
    serviceCounter++;

    // Update the IDs in the cloned section
    clonedSection.id = 'service_section_' + serviceCounter;
    clonedSection.querySelector('.mj-form__service').id = 'service_category_' + serviceCounter;
    clonedSection.querySelector('.mj-form__servicename').id = 'service_name_' + serviceCounter;
    clonedSection.querySelector('.mj-form__service').setAttribute('name', 'service_category_' + serviceCounter);
    clonedSection.querySelector('.mj-form__servicename').setAttribute('name', 'service_name_' + serviceCounter);
    clonedSection.querySelector('.remove-service-row').setAttribute('data-service-row-id', serviceCounter);


    // Clear the input field in the cloned section
    clonedSection.querySelector('.mj-form__servicename').value = '';


    // Append the cloned section to the container
    document.querySelector('.mj-supplier-services__container').appendChild(clonedSection);
}


// Declare counters outside the function
var minspendCounter = 1;
var perpersonCounter = 1;
var delegateCounter = 1;
var hirefeeCounter = 1;

function addMoreBlock(blockType) {
    // Specify the block class and counter based on the block type
    var blockClass, blockCounter;

    switch (blockType) {
        case 'minspend':
            blockClass = '.mj-pricing__minspend';
            blockContainer = '.pricing-minspend__container';
            blockCounter = minspendCounter;
            break;
        case 'perperson':
            blockClass = '.mj-pricing__perperson';
            blockContainer = '.pricing-perperson__container';
            blockCounter = perpersonCounter;
            break;
        case 'delegate':
            blockClass = '.mj-pricing__delegate';
            blockContainer = '.pricing-delegate__container';
            blockCounter = delegateCounter;
            break;
        case 'hirefee':
            blockClass = '.mj-pricing__hirefee';
            blockContainer = '.pricing-hirefee__container';
            blockCounter = hirefeeCounter;
            break;
        // Add more cases for other block types if needed

        default:
            console.error('Unsupported block type');
            return;
    }

    // Clone the existing block section
    // var clonedSection = document.querySelector(blockClass).cloneNode(true);
    var clonedSection = document.querySelector(blockClass + ":last-child").cloneNode(true);
    var lastItem = jQuery(blockClass + ":last-child").attr("id");
    blockCounter = parseInt(lastItem.split('-').pop(), 10) + 1;

    // Increment the counter for unique IDs
    // blockCounter += 1;

    // Update the IDs in the cloned section
    clonedSection.id = 'mj-pricing__' + blockType + '-' + blockCounter;

    // Update the IDs in specific elements based on block type
    updatePricingBlockIds(clonedSection, blockType, blockCounter);


    // Clear the input fields in the cloned section
    clonedSection.querySelectorAll('.mj-form__select, .mj-form__input').forEach(function (element) {
        element.value = '';
    });


    // Append the cloned section to the container
    jQuery(blockContainer).find('.pricing-options__inputs').first().append(clonedSection);
}

function updatePricingBlockIds(clonedSection, blockType, number) {
    // Get the numeric part from clonedSection's id
    // var number = (clonedSection.id.match(/\d+/) || [0])[0];
    // Combine selectors for multiple elements
    // clonedSection.querySelector(".remove-pricing-row").attr("data-price-row-id", number);
    clonedSection.querySelector(".remove-pricing-row").setAttribute("data-price-row-id", number);


    clonedSection.querySelectorAll(`[id^="${blockType}_day_"], [id^="${blockType}_hourfrom_"], [id^="${blockType}_hourto_"], [id^="${blockType}_price_"]`).forEach(function (element) {

        // Extract the non-numeric part from element's id
        var elementID = element.id.replace(/\d+/, '');

        // Update the id attribute
        element.id = elementID + number;

        // Update the name attribute
        var elementName = element.getAttribute('name');
        if (elementName) {
            element.setAttribute('name', elementName.replace(/\d+/, '') + number);
        }
    });
}

function getTotalUploadedFiles(uploadedIDs) {
    let totalFiles = 0;

    if (uploadedIDs && uploadedIDs.trim() !== "") {
        const uploadedIDsArray = uploadedIDs.split(',').map(item => item.trim());
        totalFiles = uploadedIDsArray.length;
    }

    return parseInt(totalFiles, 10);
}

jQuery(document).ready(function () {
    // Use event delegation to attach click event to dynamically loaded elements
    jQuery(document).on('click', '.remove-pricing-row', function () {
        // Get the values of data attributes
        var rowId = jQuery(this).data('price-row-id');
        var rowName = jQuery(this).data('price-row-name');
        var step = jQuery(this).data('step');
        step = step + 1;
        var formType = jQuery(this).data('form-type');


        // Construct the class name to be removed
        var classNameToRemove = 'mj-pricing__' + rowName + '-' + rowId;

        // Remove the element with the constructed class
        jQuery('#' + classNameToRemove).remove();

        // Retrieve and update stepFormData from sessionStorage
        var storedFormData = sessionStorage.getItem(formType + 'ListingData' + step);
        var stepFormData = storedFormData ? JSON.parse(storedFormData) : {};

        // Update stepFormData based on the removed pricing row
        delete stepFormData[rowName + '_day_' + rowId];
        delete stepFormData[rowName + '_hourfrom_' + rowId];
        delete stepFormData[rowName + '_hourto_' + rowId];
        delete stepFormData[rowName + '_price_' + rowId];

        // Store the updated stepFormData back into sessionStorage
        sessionStorage.setItem(formType + 'ListingData' + step, JSON.stringify(stepFormData));
    });

});

jQuery(document).ready(function () {
    // Use event delegation to attach click event to dynamically loaded elements
    jQuery(document).on('click', '.remove-video-row', function () {
        // Get the values of data attributes
        var rowId = jQuery(this).data('video-row-id');
        var step = jQuery(this).data('step');
        step = step + 1;
        var formType = jQuery(this).data('form-type');

        // Construct the class name to be removed
        var classNameToRemove = 'video_section' + '_' + rowId;

        jQuery('#' + classNameToRemove).remove();

        // Retrieve and update stepFormData from sessionStorage
        var storedFormData = sessionStorage.getItem(formType + 'ListingData' + step);
        var stepFormData = storedFormData ? JSON.parse(storedFormData) : {};

        delete stepFormData['video_source_' + rowId];
        delete stepFormData['video_url_' + rowId];

        // Store the updated stepFormData back into sessionStorage
        sessionStorage.setItem(formType + 'ListingData' + step, JSON.stringify(stepFormData));
    });

    // Use event delegation to attach click event to dynamically loaded elements
    jQuery(document).on('click', '.remove-service-row', function () {
        // Get the values of data attributes
        var rowId = jQuery(this).data('service-row-id');
        var step = jQuery(this).data('step');
        step = step + 1;
        var formType = jQuery(this).data('form-type');

        // Construct the class name to be removed
        var classNameToRemove = 'service_section' + '_' + rowId;

        jQuery('#' + classNameToRemove).remove();

        // Retrieve and update stepFormData from sessionStorage
        var storedFormData = sessionStorage.getItem(formType + 'ListingData' + step);
        var stepFormData = storedFormData ? JSON.parse(storedFormData) : {};

        delete stepFormData['service_category_' + rowId];
        delete stepFormData['service_name_' + rowId];

        // Store the updated stepFormData back into sessionStorage
        sessionStorage.setItem(formType + 'ListingData' + step, JSON.stringify(stepFormData));
    });

});

let signaturePad;

function initializeSignaturePad() {
    const signatureUrl = sessionStorage.getItem('signature-url');
    const signatureNameInput = document.getElementById("signiture-name");
    const signatureDateInput = document.getElementById("agreement-date");
    const signatureInput = document.getElementById("signature-url");
    const signaturePlaceholder = document.getElementById("signature-image");
    const signatureCanvas = document.getElementById("signiture-canvas");
    const signatureButtons = document.getElementById("signiture__btns");

    if (signatureUrl && signatureUrl.trim() !== '') {
        signaturePlaceholder.src = signatureUrl;
        signatureCanvas.style.display = "none";
        signatureButtons.style.display = "none";
    } else {
        signaturePlaceholder.style.display = "none";
        const canvas = document.querySelector("canvas");
        signaturePad = new SignaturePad(canvas, {
            minWidth: 1,
            maxWidth: 3,
            penColor: "rgb(0, 0, 0)"
        });

        function resizeCanvas() {
            const ratio = Math.max(window.devicePixelRatio || 1, 1);
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);
            signaturePad.clear();
        }

        window.addEventListener("resize", resizeCanvas);
        resizeCanvas();

        document.getElementById('signature-clear').addEventListener('click', function (event) {
            event.preventDefault();
            signaturePad.clear();
        });

        document.getElementById('signature-save').addEventListener('click', function (event) {
            event.preventDefault();

            if (signaturePad.isEmpty()) {
                showNotification("You haven't signed the Signing Agreement.", 'error');
            } else {
                uploadSignature(signaturePad.toDataURL(), signatureNameInput.value, signatureDateInput.value, this, signatureInput, signaturePlaceholder, signatureCanvas, signatureButtons);
            }
        });
    }
}

function uploadSignature(signUrl, signName, signDate, saveBtn, imgUrl, imgElement, signCanvas, signButtons) {
    const saveBtnText = saveBtn.textContent;
    const action = "upload_signature";
    const ajaxData = {
        sign_url: signUrl,
        sign_name: signName,
        sign_date: signDate,
        action: action
    };

    $.ajax({
        type: 'POST',
        url: missjones_data.ajax_url,
        data: ajaxData,
        beforeSend: function () {
            saveBtn.textContent = "Uploading...";
        },
        success: function (response) {
            if (response.success) {
                showNotification('Signature uploaded successfully.', 'success');
                sessionStorage.setItem('signature-url', response.file_url);
                imgUrl.value = response.file_url;
                imgElement.style.display = "block";
                imgElement.src = response.file_url;
                signCanvas.style.display = "none";
                signButtons.style.display = "none";
            } else {
                console.error('Error uploading signature.');
                showNotification('Error uploading signature.', 'error');
            }
        },
        error: function () {
            console.error('AJAX error occurred.');
            showNotification('AJAX error occurred.', 'error');
        },
        complete: function () {
            saveBtn.textContent = saveBtnText;
        }
    });
}

// Set your publishable key: remember to change this to your live publishable key in production
// See your keys here: https://dashboard.stripe.com/apikeys
// const stripe = Stripe('pk_test_4RxUQ9rE2xn8vIbplcQlCLQN');

// var paymentForm = document.getElementById('payment-form');

// var clientSecretValue = paymentForm.getAttribute('data-secret');


// const options = {
//     clientSecret: clientSecretValue,
//     // Fully customizable with appearance API.
//     appearance: {/*...*/ },
// };

// // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in a previous step
// const elements = stripe.elements(options);

// // Create and mount the Payment Element
// const paymentElement = elements.create('payment');
// paymentElement.mount('#payment-element');

// const form = document.getElementById('payment-form');

// form.addEventListener('submit', async (event) => {
//     event.preventDefault();

//     const { error } = await stripe.confirmPayment({
//         //`Elements` instance that was used to create the Payment Element
//         elements,
//         confirmParams: {
//             return_url: 'https://example.com/order/123/complete',
//         },
//     });

//     if (error) {
//         // This point will only be reached if there is an immediate error when
//         // confirming the payment. Show error to your customer (for example, payment
//         // details incomplete)
//         const messageContainer = document.querySelector('#error-message');
//         messageContainer.textContent = error.message;
//     } else {
//         // Your customer will be redirected to your `return_url`. For some payment
//         // methods like iDEAL, your customer will be redirected to an intermediate
//         // site first to authorize the payment, then redirected to the `return_url`.
//     }
// });

document.addEventListener('DOMContentLoaded', function () {
    jQuery('#missjones-newsletter-form').on('submit', function (event) {
        event.preventDefault(); // Prevent the default form submission

        var formData = {
            action: $(this).attr('action'),
            email: $('#email').val()
        };

        $.ajax({
            type: 'POST',
            url: missjones_data.ajax_url,
            data: formData,
            beforeSend: function () {
                jQuery("#submit_newsletter").val("Sending...");
            },
            success: function (response) {
                // Handle the response from the server
                if (response.success) {
                    showNotification('Thank you for subscribing!', 'success');
                    jQuery("#submit_newsletter").val("Subscribed");

                } else {
                    showNotification('There was an error. Please try again.', 'error');
                    jQuery("#submit_newsletter").val("Subscribe");
                }
            },
            error: function () {
                // Handle any errors
                showNotification('There was an error. Please try again.', 'error');
                jQuery("#submit_newsletter").val("Subscribe");
            }
        });
    });
});

async function initializeCountries() {
    const countrySelect = document.getElementById('country');
    const citySelect = document.getElementById('city');
    const locationSelect = document.getElementById('location');
    const areaSelect = document.getElementById('area');

    if (!countrySelect || !citySelect || !locationSelect || !areaSelect) {
        return;
    }

    const taxonomyName = countrySelect.dataset.taxonomy;

    let countryId = countrySelect.value; // Get the value of the selected option

    if (countryId) {
        // console.log(countryId);
        await updateSubCategories(countryId, 'city', taxonomyName);
    }

    let cityId = citySelect.value;
    if (cityId) {
        // console.log(cityId);
        await updateSubCategories(cityId, 'location', taxonomyName);
    }

    let locationId = locationSelect.value;
    if (locationId) {
        // console.log(locationId);
        await updateSubCategories(locationId, 'area', taxonomyName);
    }

    countrySelect.addEventListener('change', async () => {
        let countryId = countrySelect.value;
        await updateSubCategories(countryId, 'city', taxonomyName);
        let cityId = citySelect.value;
        // console.log(cityId);
        await updateSubCategories(cityId, 'location', taxonomyName);
        let locationId = locationSelect.value;
        // console.log(locationId);
        await updateSubCategories(locationId, 'area', taxonomyName);
    });

    citySelect.addEventListener('change', async () => {
        let cityId = citySelect.value;
        await updateSubCategories(cityId, 'location', taxonomyName);
        let locationId = locationSelect.value;
        await updateSubCategories(locationId, 'area', taxonomyName);
    });

    locationSelect.addEventListener('change', async () => {
        let locationId = locationSelect.value;
        await updateSubCategories(locationId, 'area', taxonomyName);
    });
}

function updateSubCategories(locationId, location, taxonomyName) {

    var formData = {
        action: 'load_country_subcategories', // AJAX action hook
        parent_id: locationId,
        taxonomy_name: taxonomyName,
        nonce: missjones_data.nonce // Assuming you have nonce in the localized script
    };

    return $.ajax({
        type: 'POST',
        url: missjones_data.ajax_url,
        data: formData,
        dataType: 'json',
        beforeSend: function () {
            // Show loading spinner before the AJAX request, if necessary
        }
    }).done(response => {
        if (response.success === true) {
            updateLocationSelectOptions(response.data, location);
        } else {
            emptyLocationOptions(location);
        }
    }).fail(error => {
        console.error('AJAX Error:', error);
    });
}

function updateLocationSelectOptions(subcategories, elementId) {
    const locationSelect = document.getElementById(elementId);
    if (!locationSelect) return;

    // Function to decode HTML entities
    function decodeHTMLEntities(text) {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = text;
        return tempElement.textContent || tempElement.innerText || "";
    }

    // Clear existing options
    locationSelect.innerHTML = '';

    // Add a default option
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = '-';
    locationSelect.appendChild(defaultOption);

    if (subcategories.length !== 0) {
        // Create and append new options
        subcategories.forEach(subcategory => {
            const option = document.createElement('option');
            option.value = subcategory.term_id;
            option.textContent = decodeHTMLEntities(subcategory.name.charAt(0).toUpperCase() + subcategory.name.slice(1));
            locationSelect.appendChild(option);
        });

        locationSelect.selectedIndex = 0;
    } else {
        locationSelect.selectedIndex = 0;
    }

    return true;
}

function emptyLocationOptions(elementId) {
    const locationSelect = document.getElementById(elementId);
    if (!locationSelect) return;

    // Clear existing options
    locationSelect.innerHTML = '';

    // Add a default option
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = '-';
    locationSelect.appendChild(defaultOption);

    locationSelect.selectedIndex = 0;
}

document.addEventListener('DOMContentLoaded', function () {
    jQuery('.missjones-enquire-form').on('submit', function (event) {
        event.preventDefault(); // Prevent the default form submission

        var form = jQuery(this); // Cache the current form
        var formAction = "submit_enquiry";
        var formData = form.serialize();
        formData += '&action=' + formAction;

        // console.log(formData);

        jQuery.ajax({
            type: 'POST',
            url: missjones_data.ajax_url,
            data: formData,
            beforeSend: function () {
                form.find(".mj-form__submit-enquiry").val("Sending...");
                form.find(".mj-form__submit-enquiry").addClass("--deactive");
            },
            success: function (response) {
                // Handle the response from the server
                // console.log(response);
                if (response.success) {
                    // showNotification(response.data, 'success');
                    showNotificationPopup(response.data, 'success', ".enquiry-form");
                    form.find(".mj-form__submit-enquiry").val("Sent");
                } else {
                    // showNotification('There was an error. Please try again.', 'error');
                    showNotificationPopup(response.data, 'error', ".enquiry-form");
                    form.find(".mj-form__submit-enquiry").val("Enquire now");
                }
                form.find(".mj-form__submit-enquiry").removeClass("--deactive");
            },
            error: function () {
                // Handle any errors
                showNotification('There was an error. Please try again.', 'error');
                form.find(".mj-form__submit-enquiry").removeClass("--deactive");
                form.find(".mj-form__submit-enquiry").val("Enquire now");
            }
        });
    });
});


function initializePricesActions() {
    document.querySelectorAll('.mj_listing_pricing_checkbox').forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            var dataType = this.getAttribute('data-type');
            var isChecked = this.checked;

            var pricesWrapper = document.querySelector('.pricing-options__wrapper[data-type="' + dataType + '"]');

            if (pricesWrapper) {
                if (isChecked) {
                    // Add Class --show
                    pricesWrapper.classList.add('--show');
                } else {
                    // Remove Class --show
                    pricesWrapper.classList.remove('--show');
                }
            }
        });
    });
}

//Click on Forget Password
document.addEventListener('DOMContentLoaded', function () {
    jQuery(document).on('submit', '#forget_form', function (event) {
        event.preventDefault(); // Prevent default form submission

        if (validateForm("#forget_form")) {
            // Prepare JSON data
            var formData = {};

            // Retrieve form action
            var formAction = "forget_password";
            formData['site_url'] = 'panel';

            formData['action'] = formAction; // Include form action in JSON data

            var inputs = this.querySelectorAll('input, select');
            inputs.forEach(function (input) {
                if (input.type === 'checkbox') {
                    formData[input.name] = input.checked ? 1 : 0; // For checkboxes, store the 'checked' state
                } else {
                    formData[input.name] = input.value; // For other input types, store the 'value'
                }
            });

            // Get the submit button
            var submitButton = this.querySelector('button[type="submit"]');

            var btnTextInProgress, btnTextDone, btnTextError;

            btnTextInProgress = "Logging in"
            btnTextDone = "Password sent."
            btnTextError = "Send activation link to email"

            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: missjones_data.ajax_url,
                data: formData,
                cache: false,
                beforeSend: function () {
                    handleSubmission(submitButton, "disable", "Sending...");
                },
                success: function (response) {
                    if (response.success) {
                        handleSubmission(submitButton, "enable", btnTextDone);
                        showNotificationPopup(response.data.message, "info", "#forget_form");
                    } else {
                        handleSubmission(submitButton, "enable", btnTextError);
                        showNotificationPopup(response.data.message, "error", "#forget_form");
                    }
                },
                error: function (data) {
                    console.log(data);
                    handleSubmission(submitButton, "enable", btnTextError);
                    showNotificationPopup("Error occurred during submission!", "error", "#forget_form");
                }
            });
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    jQuery(document).on('submit', '#reset_form', function (event) {
        event.preventDefault(); // Prevent default form submission

        if (validateForm("#reset_form")) {

            // Prepare JSON data
            var formData = {};

            formData['action'] = jQuery(this).find("#action").val();
            formData['key'] = jQuery(this).find("#key").val();
            formData['login'] = jQuery(this).find("#login").val();

            var inputs = this.querySelectorAll('input, select');
            inputs.forEach(function (input) {
                if (input.type === 'checkbox') {
                    formData[input.name] = input.checked ? 1 : 0; // For checkboxes, store the 'checked' state
                } else {
                    formData[input.name] = input.value; // For other input types, store the 'value'
                }
            });

            // Get the submit button
            var submitButton = this.querySelector('button[type="submit"]');

            var btnTextInProgress, btnTextDone, btnTextError;

            btnTextInProgress = "In progress..."
            btnTextDone = "Password changed successfully!"
            btnTextError = "Error!"

            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: missjones_data.ajax_url,
                data: formData,
                cache: false,
                beforeSend: function () {
                    handleSubmission(submitButton, "disable", "Sending...");
                },
                success: function (response) {
                    console.log(response);
                    if (response.success) {
                        // If the server returns success
                        showNotificationPopup(response.data.message, "info", "#reset_form");

                        var newUrl = `${site_url_wpml()}`; // Append the query parameter to the base URL
                        window.location.href = newUrl;

                    } else {
                        handleSubmission(submitButton, "enable", btnTextError);
                        // If the server returns an error
                        showNotificationPopup(response.data.message, "error", "#reset_form"); // Display error message
                    }
                },
                error: function (data) {
                    console.log(data);
                    handleSubmission(submitButton, "enable", 'Reset password');
                    showNotificationPopup("Error", "error", "#reset_form");
                }
            });
        }
    });
});